export const storeFinder = {
  storeFinder: {
    openUntil: 'Open until',
    closed: 'Closed',
    back: 'Back',
    call: 'Call',
    getDirections: 'Get Directions',
    ariaLabelGetDirections: 'Get Directions, this link opens in a new window',
    listView: 'List View',
    mapView: 'Map View',
    noStoresFound: 'No Stores Found.',
    storeHours: 'Store hours',
    storeFeatures: 'Store features',
    fromStoresFound: 'from {{ count }} store found',
    fromStoresFound_plural: 'from {{ count }} stores found',
    findStore: 'Find store',
    useMyLocation: 'Use my location',
    viewAllStores: 'View all stores',
    contactUs: 'Contact us',
    searchBox: 'Enter postal code, town or address',
    backToList: 'Back to list',
    noStoresMessage: 'No stores found in database...',
    geolocationNotEnabled:
      'Cannot locate nearby stores. Geolocation consent has not been enabled',
  },
};
